import { render, staticRenderFns } from "./PracaForm.vue?vue&type=template&id=54efa013&scoped=true&lang=pug&"
import script from "./PracaForm.vue?vue&type=script&lang=js&"
export * from "./PracaForm.vue?vue&type=script&lang=js&"
import style0 from "./PracaForm.vue?vue&type=style&index=0&id=54efa013&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54efa013",
  null
  
)

export default component.exports